import { I18nextLocale, UNDERSCORE_TO_I18NEXT_LOCALE } from '../i18n';
import { UnderscoreLocale } from './types';

export const getI18nLocale = (locale: UnderscoreLocale): I18nextLocale => {
  const result = UNDERSCORE_TO_I18NEXT_LOCALE.get(locale);

  if (!result) {
    throw new Error(`Unsupported locale: ${locale}`);
  }
  return result;
};
